import { createRoute, redirect } from '@tanstack/react-router';
import { Route as parent } from './signed-in.tsx';
export const Route = createRoute({
  getParentRoute: () => parent,
  path: '/chats/$chatId',
  beforeLoad: ({ params, search }) => {
    throw redirect({ to: '/', search: { ...search, chatId: params.chatId }, replace: true });
  },
});
